
import endpoints from './endpoints';
import { apiAction } from './api';
import dateUtil from '../util/dateUtil';
import { RECEIPT_POLLING_INTERVAL_MS } from '../config/staticValues';
export const RESET_RECEIPT = 'RESET_RECEIPT';
export const RECEIPT_ANALYZE_PREP = 'RECEIPT_ANALYZE_PREP';
export const RECEIPT_ANALYZE_POLL = 'RECEIPT_ANALYZE_POLL';
export const RECEIPT_ANALYZE_SUCCESS = 'RECEIPT_ANALYZE_SUCCESS';
export const RECEIPT_ANALYZE_ERROR = 'RECEIPT_ANALYZE_ERROR';
export const RECEIPT_VALIDATION_ERROR = 'RECEIPT_VALIDATION_ERROR';
export const OPEN_UPLOAD_RECEIPT = 'OPEN_UPLOAD_RECEIPT';
export const RESET_UPLOAD_RECEIPT = 'RESET_UPLOAD_RECEIPT';
export const OPEN_CAPTURE_RECEIPT = 'OPEN_CAPTURE_RECEIPT';
export const RESET_CAPTURE_RECEIPT = 'RESET_CAPTURE_RECEIPT';
export const MARK_DELETED_RECEIPT = 'MARK_DELETED_RECEIPT';

export const analyzeReceipt = (payload) => {
    const formData = new FormData();
    formData.append('file', payload.file);

    return apiAction({
        url: endpoints.receiptAnalysis,
        method: 'POST',
        formData: formData,
        onSuccess: [
            (response) => analyzeReceiptPollStart(response)
        ],
        onFailure: (error) =>
            analyzeReceiptError(error)
    });
};
export const prepReceipt = (payload) => {
    return {
        type: RECEIPT_ANALYZE_PREP,
        payload: payload,
    };
};
export const analyzeReceiptPollStart = (data) => (dispatch, getState) => {
    try {
        const resultUrl = data.resultUrl;
        dispatch({
            type: RECEIPT_ANALYZE_POLL,
            payload: resultUrl
        });
        setTimeout(() => {
            dispatch(analyzeReceiptPoll(resultUrl));
        }, RECEIPT_POLLING_INTERVAL_MS);
    }
    catch (error) {
        dispatch(analyzeReceiptError(error));
    }
};
export const analyzeReceiptPoll = (resultUrl) => {
    return apiAction({
        url: endpoints.receiptAnalysis,
        method: 'GET',
        data: { resultUrl },
        onSuccess: [
            (response) => analyzeReceiptSuccess(response, resultUrl)
        ],
        onFailure: (error) =>
            analyzeReceiptError(error)
    });
};
export const analyzeReceiptSuccess = (data, resultUrl) => {
    try {
        if (data.result?.status == 'succeeded') {
            const total = data.result.analyzeResult.documents[0]?.fields?.Total?.valueNumber;
            const date = data.result.analyzeResult.documents[0]?.fields?.TransactionDate?.valueDate;
            const entryData = {
                ...(total != null && { expenseAmount: total }),
                ...(date != null && { startDate: dateUtil.toDateString(dateUtil.stringToDate(date)) }),
            };// only set the properties if we can get them
            return {
                type: RECEIPT_ANALYZE_SUCCESS,
                payload: entryData
            };
        } else {
            return analyzeReceiptPollStart({ resultUrl });
        }
    }
    catch (error) {
        return analyzeReceiptError(error);
    }
};
export const analyzeReceiptError = (error) => {
    console.error("POST2 ERROR store.receipt.analyzeReceiptError", error);
    return {
        type: RECEIPT_ANALYZE_ERROR,
        payload: error.message
    };
};
export const validationReceiptError = (error) => {
    return {
        type: RECEIPT_VALIDATION_ERROR,
        payload: error
    };
};
export const resetReceipt = () => {
    return {
        type: RESET_RECEIPT
    };
};
export const markReceiptDeleted = () => {// marks existing file in SQL to be deleted
    return {
        type: MARK_DELETED_RECEIPT
    };
};
export const openUploadReceipt = () => {
    return {
        type: OPEN_UPLOAD_RECEIPT,
    };
};
export const resetUploadReceipt = () => {
    return {
        type: RESET_UPLOAD_RECEIPT,
    };
};
export const openCaptureReceipt = () => {
    return {
        type: OPEN_CAPTURE_RECEIPT,
    };
};
export const resetCaptureReceipt = () => {
    return {
        type: RESET_CAPTURE_RECEIPT,
    };
};

const initialState = {
    receipt: null,
    openUploadReceipt: false,
    openCaptureReceipt: false,
    loading: false,
    analyzeResultUrl: null,
    analyzeError: null,// from GET or POST request
    validationError: null, // from react-images-uploading
    markDeleted: false // mark existing file in SQL to be deleted
};

export const receipt = (state = initialState, action) => {
    switch (action.type) {
        case RESET_RECEIPT:
            return {
                ...state,
                receipt: null,
                openUploadReceipt: false,
                openCaptureReceipt: false,
                loading: false,
                analyzeResultUrl: null,
                analyzeError: null,
                validationError: null,
                markDeleted: false
            };
        case RECEIPT_ANALYZE_PREP:
            return {
                ...state,
                receipt: action.payload,
                loading: true,
                analyzeResultUrl: null,
                analyzeError: null,
                validationError: null
            };
        case RECEIPT_ANALYZE_POLL:
            return {
                ...state,
                analyzeResultUrl: action.payload
            };
        case RECEIPT_ANALYZE_SUCCESS:
            return {
                ...state,
                loading: false,
                analyzeResultUrl: null
            };
        case RECEIPT_ANALYZE_ERROR:
            return {
                ...state,
                loading: false,
                analyzeResultUrl: null,
                analyzeError: action.payload
            };
        case RECEIPT_VALIDATION_ERROR:
            return {
                ...state,
                loading: false,
                validationError: action.payload
            };
        case OPEN_UPLOAD_RECEIPT:
            return {
                ...state,
                openUploadReceipt: true,
                openCaptureReceipt: false
            };
        case RESET_UPLOAD_RECEIPT:
            return {
                ...state,
                openUploadReceipt: false
            };
        case OPEN_CAPTURE_RECEIPT:
            return {
                ...state,
                openUploadReceipt: false,
                openCaptureReceipt: true
            };
        case RESET_CAPTURE_RECEIPT:
            return {
                ...state,
                openCaptureReceipt: false
            };
        case MARK_DELETED_RECEIPT:
            return {
                ...state,
                markDeleted: true
            };
        default:
            return state;
    }
};
